export default __webpack_public_path__ + "static/media/mail.da758143.svg";